import { render, staticRenderFns } from "./safe-plan.vue?vue&type=template&id=45264419&scoped=true&"
import script from "./safe-plan.vue?vue&type=script&lang=js&"
export * from "./safe-plan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45264419",
  null
  
)

export default component.exports